module.exports = __webpack_public_path__ + "static/img/除油煙機.fb293868.png";